import { AxiosInstance } from 'axios';

/**
 * Axios request interceptor that adds `prefix` to the beginning of the path portion of each request URL.
 */
const withPathPrefix = (prefix: string) => (axios: AxiosInstance) => {
  axios.interceptors.request.use(requestConfig => {
    return {
      ...requestConfig,
      url: prefix + requestConfig.url,
    };
  });

  return axios;
};

export default withPathPrefix;
